<template>
    <el-select v-model="values" placeholder="请选择" @change="change" clearable style="width: 100%;">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
    name: "YearSelect",
    data(){
        return{
            list:[],
            values:''
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        value:{
            type:[String,Number],
            default:''
        }
    },
    created() {
        this.values = this.value ? parseInt(this.value) : '';
    },
    watch:{
        value(n,o){
            this.values = n ? parseInt(n) : '';
        }
    },
    mounted() {
        let _now = new Date();
        let _year = _now.getFullYear();
        for(let i = _year;i > _year - 30;i--){
            this.list.push({id:i,name:i+'年'});
        }
    },
    methods:{
        change(e){
            this.$emit("change", e);
        }
    }
}
</script>
